import { useAppState } from '../context/OmniboxJsonConverterContext';
import { GenerateCsvForEntry } from './csvUtils';
import {
  Button,
  Chip,
  Stack,
  Typography,
} from '@mui/material';


function RenderResults() {
  const { inputFiles } = useAppState();

  return (
    <Stack direction='column' spacing={2} sx={{ mt: 1 }}>
      <Stack direction='row' alignItems='center' justifyContent='space-between'>
        <Typography variant='h5'>Results</Typography>
        <Button
          variant='contained'
          size='small'
          onClick={async () => {
            for (const entry of inputFiles) {
              if (entry.status === 'ready') {
                const a = document.createElement('a');
                a.href = entry.csvUrl;
                a.download = entry.fileName + '.csv';
                a.click();
                a.remove();
                await new Promise(res => setTimeout(res, 300));
              }
            }
          }}
        >
          Download All
        </Button>
      </Stack>

      {inputFiles.map((entry) =>
        <Stack
          direction='row'
          alignItems='center'
          sx={{
            p: 1,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            justifyContent: 'space-between'
          }}
        >
          <Stack direction='row' spacing={1}>
            <Typography variant='body1'>{entry.fileName}</Typography>
            <Stack direction='row' spacing={.75} alignItems='center'>
              <Chip
                label={entry.status} color={entry.status === 'error' ? 'error' : entry.status === 'ready' ? 'success' : 'warning'}
                size='small'
                variant='outlined'
                sx={{
                  width: 'auto',
                  fontSize: '12px',
                  alignSelf: 'flex-start'
                }}
              />
              {entry.status === 'error' ? <Typography variant='caption' color='text.secondary'>{entry.parseError}</Typography> : null}
            </Stack>
          </Stack>
          <Button
            variant='outlined'
            disabled={entry.status !== 'ready'}
            size='small'
            onClick={() => {
              const a = document.createElement('a');
              a.href = entry.csvUrl;
              a.download = entry.fileName + '.csv';
              a.click();
              a.remove();
            }}
          >
            Download
          </Button>
        </Stack>
      )}
    </Stack>
  )
}

export default RenderResults;